export const oneDecimal = (x: number): string => {
  if (~~x === x) return x.toString() + ".0";
  else return x.toString();
};
